import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useUploadFileMutation } from '../api';
import { useNotifications } from '@/features/notifications';
import { NDA_FOLDER_ID } from '@/config';

export type UseUploadOpportunityFileProps = {
    opportunityId: string;
};

export function useUploadOpportunityFile({ opportunityId }: UseUploadOpportunityFileProps) {

    const { t } = useTranslation();
    const { add } = useNotifications();

    const [uploadFileMutation, { isLoading: isUploading }] = useUploadFileMutation();

    const uploadFile = useCallback(
        async (file: File, type: 'nda' | 'other' = 'nda') => {
            try {

                const uploadResult = await uploadFileMutation({
                    file,
                    folder: NDA_FOLDER_ID,
                }).unwrap();

                add({
                    id: new Date().toString(),
                    title: t('File uploaded successfully'),
                    description: t('Your NDA has been uploaded'),
                });

                return uploadResult;
            } catch (error) {
                add({
                    id: new Date().toString(),
                    title: t('ERROR'),
                    description: t('There was an error uploading the file. Please try again later.'),
                });
                throw error;
            }
        },
        [opportunityId, uploadFileMutation, add, t]
    );

    return {
        uploadFile,
        isLoading: isUploading
    };
}
